module.exports = __webpack_public_path__ + "src/assets/img/eng-hot-green.6293928f.svg";